

var hostCopyRight = [
  {'zj.52khg.cn':'纸巾侠'},
  {'gxzj.laibaozhi.com':'共享纸巾'},
  {'sj.laibaozhi.com':'来包纸'},
  {'suoli':'索力'},
  {'lx.liuxiangok.cn':'流享'},
  {'xgl.laibaozhi.com':'香格里共享纸巾'},
  {'yunzhi.ynstkz.com':'芸纸共享纸巾'},
  {'127.0.0.1':'本地'},
  {'zj.dingdangwu.cn':'纸巾侠'}
]



function getCopyRight(){
   var host = window.location.host

  for (var i=0; i<hostCopyRight.length; i++){
    var temp = hostCopyRight[i]

    // console.log("temp = "+JSON.stringify(temp))

    for(var p in temp){

    //  console.log("p="+p+",host="+host)

     if(host.indexOf(p)>=0){
       return temp[p]
     }
    }
  }

  return ''
}


// 很关键
export {
    getCopyRight
}



//////////////////
// WEBPACK FOOTER
// ./static/copyright.js
// module id = QgCX
// module chunks = 0